import * as React from "react";
import { Link } from "react-router-dom";
import { Icon } from "affinityIcons/Icon";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

import logoSrc from "./logo.svg";

const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background: ${(props) => props.theme.colours.primary};
  color: ${(props) => props.theme.colours.white};
  min-height: 3.5rem;

  ${({ theme }) => theme.breakpoints.up("xl")} {
    padding: 0 1.5rem;
    min-height: 4.5rem;
  }
  a {
    text-decoration: none;
  }
`;

const Logo = styled.span`
  display: inline-block;
  padding-right: 1rem;
  ${({ theme }) => theme.breakpoints.up("xl")} {
    padding-right: 1.5rem;
  }
`;

const Img = styled.img`
  display: block;
  width: 2rem;
`;

const Menu = styled.div`
  display: flex;
`;

const Extra = styled.div`
  margin-left: auto;
  min-width: 0;
`;

const Item = styled.span`
  ${typeScale.md}
  padding: 1rem;
  display: flex;
  align-items: center;
  ${Icon} {
    font-size: 1.3rem;
    margin-right: 0.4rem;
  }
  ${({ theme }) => theme.breakpoints.up("xl")} {
    padding: 1.5rem;
  }

  box-sizing: border-box;
  & * {
    border: none;
    text-decoration: none;
  }
  appearance: none;
  background: transparent;
  color: ${({ theme }) => theme.colours.white};
  cursor: pointer;
  font-weight: bold;

  &:hover {
    box-shadow: inset 0px -4px 0px 0px ${({ theme }) => theme.colours.highlight};
  }
  .active & {
    background: ${({ theme }) => theme.colours.blue[600]};
  }
`;

export const NavBar: React.FC<React.PropsWithChildren> & {
  Menu: typeof Menu;
  Item: typeof Item;
  Extra: typeof Extra;
} = ({ children }) => (
  <Header data-testid="nav-bar">
    <Logo>
      <Link to="/">
        <Img src={logoSrc} alt="Entia Liberty" height="100%" />
      </Link>
    </Logo>
    {children}
  </Header>
);
NavBar.Menu = Menu;
NavBar.Item = Item;
NavBar.Extra = Extra;
